import { useEffect, useState } from "react"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { useStoryblokBreadcrumb } from "../../../../hooks/useStoryblokBreadcrumb"
import { fetchSbStories } from "../../../../lib/api"
import { type SbFaqArticleB2bgStory, type SbFaqCategoryB2bgStory } from "../../../../types"
import { getParams } from "../../../../utils/getParams"
import { StoryblokFAQCategory } from "../../../FAQCategory"

type FaqCategoryB2bgTemplateProps = {
    story: SbFaqCategoryB2bgStory
}

export function FaqCategoryB2bgTemplate({ story }: FaqCategoryB2bgTemplateProps) {
    const { title } = story.content
    const [stories, setStories] = useState<Array<SbFaqArticleB2bgStory>>([])
    const [isLoading, setIsLoading] = useState(true)
    const crumbs = useStoryblokBreadcrumb({
        story,
        root: {
            href: storyblokRoutesPaths.faqBusiness.resolve(),
            title: "FAQ entreprises et collectivités",
        },
    })

    const options = getParams(false, {
        starts_with: `aide-faq-entreprises-collectivites/${story.slug}/`,
        excluding_ids: story.id.toString(),
        content_type: "faqCategoryB2bg",
    })

    useEffect(() => {
        const fetchStories = async () => {
            try {
                const stories = await fetchSbStories({
                    starts_with: story.full_slug,
                    excluding_ids: story.id.toString(),
                    content_type: "faqArticleB2bg",
                })

                setStories(stories)
            } catch (error) {
                console.error(`Could not find stories with category slug ${story.full_slug}`, error)
            }

            setIsLoading(false)
        }

        void fetchStories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <StoryblokFAQCategory
            crumbs={crumbs}
            title={title}
            options={options}
            stories={stories}
            isLoading={isLoading}
        />
    )
}
